import React from 'react';

interface RobertBruggemanProps {
  onLearnMore?: () => void;
}

interface BackgroundParagraph {
  text: string;
  boldPhrases: string[];
}

const RobertBruggeman: React.FC<RobertBruggemanProps> = ({ onLearnMore }) => {

  const backgroundParagraphs: BackgroundParagraph[] = [
    {
      text: "Robert Bruggeman isn’t a hobbyist or armchair analyst. He’s a seasoned stock analyst who traded for one of Canada’s top banks, racking up profits in bull and bear markets alike. His decades of experience, combined with hands-on work inside exploration companies, gives him a major edge in identifying mining companies to invest in. His crowning achievement? Growing AbraSilver by over 10,000%. Now, he’s sharing his hedge fund-tested playbook to help you master junior mining stocks and build serious wealth.",
      boldPhrases: ["a seasoned stock analyst", "decades of experience, combined with hands-on work inside exploration companies", "10,000%"]
    }
  ];

  const handleImageClick = () => {
    console.log('Robert Bruggeman image clicked');
  };

  const renderParagraphWithBold = (paragraph: BackgroundParagraph) => {
    let processedText = paragraph.text;
    
    paragraph.boldPhrases.forEach(phrase => {
      const regex = new RegExp(`(${phrase})`, 'gi');
      processedText = processedText.replace(regex, '<strong>$1</strong>');
    });

    return processedText;
  };

  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-white pt-20 pb-20">
      <div className="">
                 {/* Grid layout */}
         <div className="grid lg:grid-cols-2 gap-12 items-center">
           {/* Image Column for desktop */}
           <div className="lg:order-1 hidden lg:block">
             <div 
               className="relative group"
               onClick={handleImageClick}
             >
               <img 
                 src="/images/RobertBruggeman.webp" 
                 alt="Robert Bruggeman - Industry Insider" 
                 className="w-full h-auto"
               />
             </div>
           </div>

           {/* Text Column */}
           <div className="space-y-6 lg:order-2 order-1">
             {/* Main Title */}
             <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#1A2A44] mb-7 lg:text-left">
               Meet Robert Bruggeman<br />
               Your Industry Insider
             </h2>

             {/* Image for mobile */}
             <div 
               className="relative group block lg:hidden w-full max-w-sm mx-auto"
               onClick={handleImageClick}
             >
               <img 
                 src="/images/RobertBruggeman.webp" 
                 alt="Robert Bruggeman - Industry Insider" 
                 className="w-full h-auto"
               />
             </div>

             {/* Professional Background */}
             <div className="space-y-4">
               {backgroundParagraphs.map((paragraph, index) => (
                 <p 
                   key={index}
                   className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0"
                   dangerouslySetInnerHTML={{ __html: renderParagraphWithBold(paragraph) }}
                 />
               ))}
             </div>
           </div>
         </div>
       </div>
     </section>
  );
};

export default RobertBruggeman;
